import { createAsyncThunk } from "@reduxjs/toolkit";
import { tasksListDataByIdSelector } from "../../selectors/data/tasksListDataByIdSelector";
import { setTaskManagementTaskTarget } from "../../taskManagementSlice";
import { RootState } from "@/store/store";
import { ResourceTarget } from "@/services/cloudchipr.api";
import { openDrawerForTaskByIdThunk } from "@/store/task-management/thunks/task-drawer-openers/openDrawerForTaskByIdThunk";

export const openDrawerForTaskByIdInResourceGridThunk = createAsyncThunk(
  "taskManagement/openDrawerForTaskByIdInResourceGrid",
  async (
    {
      taskId,
      resourcesMasterGridId,
    }: { taskId: string; resourcesMasterGridId: string },
    { dispatch, getState },
  ) => {
    const state = getState() as RootState;

    const task = tasksListDataByIdSelector(state, taskId);

    if (!task) {
      return;
    }

    dispatch(openDrawerForTaskByIdThunk(taskId));

    dispatch(
      setTaskManagementTaskTarget({
        type: "resource",
        resourcesMasterGridId,
        resources: [task.target as ResourceTarget],
      }),
    );
  },
);
